import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {ColorConfiguration} from "./color-configuration";

@JsonObject()
export class LineCallout3DBorderConfiguration {
    /**
     * The color of the callout line border.
     *
     * @default white
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-symbols-callouts-LineCallout3D.html#border)
     */
    @JsonProperty()
    declare color?: ColorConfiguration | number[] | string;

    constructor() {}
}

@JsonObject()
export class Callout3DConfiguration {
    constructor() {}
}

@JsonObject()
export class LineCallout3DConfiguration extends Callout3DConfiguration {
    /**
     * The border settings of the callout line. The border of the callout line can be used to improve the contrast of
     * the callout line color against various background colors. If the border is `null`, then no border will
     * be visible.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-symbols-callouts-LineCallout3D.html#border)
     */
    @JsonProperty()
    declare border?: LineCallout3DBorderConfiguration;
    /**
     * The color of the callout line.
     *
     * @default "black"
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-symbols-callouts-LineCallout3D.html#color)
     */
    @JsonProperty()
    declare color?: ColorConfiguration | number[] | string;
    /**
     * The width of the callout line in points.
     *
     * @default 1px
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-symbols-callouts-LineCallout3D.html#size)
     */
    @JsonProperty()
    declare size?: number | string;
    /**
     * For LineCallout3D the type is always `line`.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-symbols-callouts-LineCallout3D.html#type)
     */
    @JsonProperty()
    declare type?: string;

    constructor() {
        super();
    }
}
